import {postRequest} from "../../utils/api"

export const getLessonBasePageList = (params) => {
    return postRequest('/core/lesson/base/findList',params)
}
export const getLessonBaseListAll = () => {
    return postRequest('/core/lesson/base/findAll')
}
export const addLessonBase = (params) => {
    return postRequest('/core/lesson/base/save',params)
}

export const updateLessonBase = (params) => {
    return postRequest('/core/lesson/base/update',params)
}
export const uploadLessonBasePhoto = (params) => {
    return postRequest('/core/lesson/base/uploadPhoto',params)
}
export const deleteLessonBase = (params) => {
    return postRequest('/core/lesson/base/delete',params)
}
export const getLessonBaseList = () => {
    return postRequest('/core/lesson/base/findAllList')
}

export const getLessonBaseFindTree = () => {
    return postRequest('/core/lesson/base/lessonBaseFindTree')
}